<template>
  <v-card style="padding: 15px">
    <v-layout class="mt-3" row wrap style="justify-content: space-evenly">
      <v-flex xs12 sm5>
        <div class="body__card__header">
          <div class="body__card__title">Profit & Loss Order</div>
          <v-container>
            <div class="px-0">
              <div>
                Gross Profit Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_order.GP.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-4">
                <span>• Manager</span>
                <span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_order.GP.manager >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.manager}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_order.GP.weserve >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.weserve}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.GP.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div class="mt-3 px-0">
              <div>
                Extra Transport Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_order.extra_transport.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_order.extra_transport.manager >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.manager}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_order.extra_transport.weserve >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.weserve}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.extra_transport.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div class="mt-3 px-0">
              <div>
                Small Order Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_order.small_order.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.small_order.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.small_order.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div class="mt-3 px-0" style="color: red">
              <div>
                Promotion Discount Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_order.promotion.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.promotion.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.promotion.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div
              class="mt-5 p-3"
              style="
                background: #fffbd9 0% 0% no-repeat padding-box;
                border: 1px solid #ffd600;
                border-radius: 4px;
                opacity: 1;
                padding: 10px;
              "
            >
              <div>Summary</div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_order.summary_order.manager >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.manager}`
                      : `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_order.summary_order.weserve >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.weserve}`
                      : `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_order.summary_order.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
          </v-container>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div class="body__card__header">
          <div class="body__card__title">Profit & Loss Rider</div>
          <v-container>
            <div class="px-0">
              <div>
                Additional Fee Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_rider.fee_delivery_differentail.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span>
                <span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_rider.fee_delivery_differentail
                      .manager >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.manager}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_rider.fee_delivery_differentail
                      .weserve >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.weserve}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery_differentail.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div class="mt-3 px-0">
              <div>
                Fee Delivery Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_rider.fee_delivery.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_rider.fee_delivery.manager >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.manager}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_rider.fee_delivery.weserve >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.weserve}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.fee_delivery.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div class="mt-3 px-0" style="color: red">
              <div>
                Guarantee Fee Price ({{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss
                    .data_profit_and_loss_rider.guarantee_fee.total
                }}
                Credit)
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.guarantee_fee.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.guarantee_fee.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
            <div class="mt-5 px-3" style="padding: 24px"></div>
            <div
              class="mt-5 p-3"
              style="
                background: #fffbd9 0% 0% no-repeat padding-box;
                border: 1px solid #ffd600;
                border-radius: 4px;
                opacity: 1;
                padding: 10px;
              "
            >
              <div>Summary</div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Manager</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_rider.summary_rider.manager >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.manager}`
                      : `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.manager}`
                  }}
                  CREDIT</span
                >
              </div>
              <div class="d-flex justify-content-between mt-2 ms-3">
                <span>• Weserve</span
                ><span class="align_end"
                  >{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_profit_and_loss
                      .data_profit_and_loss_rider.summary_rider.weserve >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.weserve}`
                      : `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.data_profit_and_loss_rider.summary_rider.weserve}`
                  }}
                  CREDIT</span
                >
              </div>
            </div>
          </v-container>
        </div>
      </v-flex>
    </v-layout>
    <div
      style="
        background: #fffbd9 0% 0% no-repeat padding-box;
        border: 1px solid #ffd600;
        border-radius: 4px;
        opacity: 1;
        padding: 20px;
      "
      class="my-4 mx-5 body__card__header"
    >
      <div>Summary Profit & Loss</div>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-layout>
            <v-flex xs12 sm4>
              <span>• Manager</span>
            </v-flex>
            <v-flex xs12 sm4></v-flex>
            <v-flex xs12 sm4 class="align_end">
              <span
                >{{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss.summary_profit_and_loss
                    .manager >= 0
                    ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.summary_profit_and_loss.manager}`
                    : `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.summary_profit_and_loss.manager}`
                }}
                CREDIT</span
              >
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12>
          <v-layout>
            <v-flex xs12 sm4>
              <span>• Weserve</span>
            </v-flex>
            <v-flex xs12 sm4></v-flex>
            <v-flex xs12 sm4 class="align_end">
              <span
                >{{
                  settransactionProfit.data.transaction_order
                    .transaction_partner_profit_and_loss.summary_profit_and_loss
                    .weserve >= 0
                    ? `+${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.summary_profit_and_loss.weserve}`
                    : `${settransactionProfit.data.transaction_order.transaction_partner_profit_and_loss.summary_profit_and_loss.weserve}`
                }}
                CREDIT</span
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <v-layout row wrap style="justify-content: space-evenly">
      <v-flex xs12 sm5>
        <div class="body__card__header">
          <div class="body__card__title">Transaction Order</div>
          <div class="p-10 d-flex">
            <v-container>
              <v-flex :span="12" class="d-flex">
                <div>
                  <span>Code :</span>
                  <span
                    >{{
                      settransactionProfit.data.transaction_order
                        .transaction_partner_order_code
                    }}
                  </span>
                </div>
                <div>
                  <span>Type :</span>
                  <span
                    >{{
                      settransactionProfit.data.transaction_order
                        .transaction_partner_type
                    }}
                  </span>
                </div>
              </v-flex>
              <v-flex :span="24" class="mt-3 d-flex">
                <div>
                  <span>Description :</span>
                  <span>{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_description || "-"
                  }}</span>
                </div>
                <div style="margin-right: 7vw">
                  <span>Credit :</span>
                  <span class="ms-2 card__content__value">{{
                    settransactionProfit.data.transaction_order
                      .transaction_partner_we_credit >= 0
                      ? `+${settransactionProfit.data.transaction_order.transaction_partner_we_credit}`
                      : `-${settransactionProfit.data.transaction_order.transaction_partner_we_credit}`
                  }}</span>
                </div>
              </v-flex>
              <v-flex :span="12" class="mt-3"
                ><span class="card__content__title">Date/Time :</span
                ><span class="ms-2 card__content__value">{{
                  moment(
                    settransactionProfit.data.transaction_order.create_at
                  ).format("YYYY-MM-DD HH:mm")
                }}</span></v-flex
              >
            </v-container>
          </div>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div class="body__card__header">
          <div class="body__card__title">Rider Information</div>
          <div class="p-10">
            <v-layout>
              <v-container>
                <v-flex :span="12" class="d-flex">
                  <div>
                    <span class="card__content__title">Current rider:</span>
                    <span class="ms-2 card__content__value"
                      >{{
                        settransactionProfit.data.rider_information.rider_name
                      }}
                    </span>
                  </div>
                  <div>
                    <span>Tel :</span>
                    <span
                      >{{
                        settransactionProfit.data.rider_information.rider_tel
                      }}
                    </span>
                  </div>
                </v-flex>
                <v-flex :span="12" class="d-flex mt-3">
                  <div>
                    <span class="card__content__title">Area :</span>
                    <span class="ms-2 card__content__value"
                      >{{
                        settransactionProfit.data.transaction_order
                          .transaction_partner_description || "-"
                      }}
                    </span>
                  </div>
                  <div style="margin-left: 5vw">
                    <span>Vehicle type :</span>
                    <span
                      >{{
                        settransactionProfit.data.rider_information
                          .rider_vehicle_type
                      }}
                    </span>
                  </div>
                </v-flex>
              </v-container>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-5" v-if="settransactionProfit.data.order.order_type == 1">
      <div>
        <div class="body__card__title">
          Detail order #{{ settransactionProfit.data.order.order_code }}
        </div>
        <v-layout row wrap style="justify-content: space-evenly">
          <v-flex xs12 sm5>
            <div>
              <div style="font-size: 16px; font-weight: 500; height: 7.5vh">
                <p style="text-align: center; position: relative; top: 2.5vh">
                  Order Information
                </p>
              </div>
              <hr />
              <v-layout row wrap>
                <v-flex xs6 sm12
                  ><span class="card__content__title">Status :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_status == 1
                      ? "Order made"
                      : settransactionProfit.data.order.order_status == 2
                      ? "Inqueue"
                      : settransactionProfit.data.order.order_status == 3
                      ? "Cooking"
                      : settransactionProfit.data.order.order_status == 4
                      ? "Ready to pick"
                      : settransactionProfit.data.order.order_status == 5
                      ? "On the way"
                      : settransactionProfit.data.order.order_status == 6
                      ? "Completed"
                      : settransactionProfit.data.order.order_status == 7
                      ? "Canceled"
                      : "OTher"
                  }}</span></v-flex
                >
              </v-layout>
              <div style="display: flex">
                <v-flex :span="12" class="mt-3"
                  ><span class="card__content__title">Order start date :</span
                  ><span class="ms-2 card__content__value">{{
                    moment(
                      settransactionProfit.data.order.order_time_start
                    ).format("YYYY-MM-DD")
                  }}</span></v-flex
                >
                <v-flex :span="12" class="mt-3"
                  ><span class="card__content__title">Order start time :</span
                  ><span class="ms-2 card__content__value">{{
                    moment(
                      settransactionProfit.data.order.order_time_start
                    ).format("HH:mm")
                  }}</span></v-flex
                >
              </div>
              <div style="display: flex">
                <v-flex :span="12" class="mt-3"
                  ><span class="card__content__title">Order end date :</span
                  ><span class="ms-2 card__content__value">{{
                    moment(
                      settransactionProfit.data.order.order_time_end
                    ).format("YYYY-MM-DD")
                  }}</span></v-flex
                >
                <v-flex :span="12" class="mt-3"
                  ><span class="card__content__title">Order end time :</span
                  ><span class="ms-2 card__content__value">{{
                    moment(
                      settransactionProfit.data.order.order_time_end
                    ).format("HH:mm")
                  }}</span></v-flex
                >
              </div>
              <div style="display: flex">
                <v-flex :span="12" class="mt-3"
                  ><span class="card__content__title">Pay by :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_payment_type == 1
                      ? "COD"
                      : settransactionProfit.data.order.order_payment_type == 2
                      ? "Credit card"
                      : settransactionProfit.data.order.order_payment_type == 3
                      ? "PromptPay"
                      : settransactionProfit.data.order.order_payment_type == 4
                      ? "COIN"
                      : settransactionProfit.data.order.order_payment_type == 5
                      ? "AR"
                      : "Other"
                  }}</span></v-flex
                >
                <v-flex :span="12" class="mt-3"
                  ><span class="card__content__title">Order area :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_district_name
                  }}</span></v-flex
                >
              </div>
              <v-flex :span="24" class="mt-3"
                ><span class="card__content__title">Note to rider :</span
                ><span class="ms-2 card__content__value">{{
                  settransactionProfit.data.order.order_transfer_note || "-"
                }}</span></v-flex
              >
              <div
                style="background-color: #f3f5f7; padding: 1vw"
                class="p-5 mt-5"
              >
                <div>
                  <span class="card__content__title">Store name :</span>
                  <span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_store.store_name_th
                  }}</span>
                </div>
                <div class="mt-3">
                  <span class="card__content__title">Store Tel. :</span
                  ><span
                    class="ms-2 card__content__value"
                    v-for="(store_tel, index) in settransactionProfit.data.order
                      .order_store.store_tel"
                    :key="index"
                    >{{ (index == 0 ? "" : ", ") + `${store_tel.tel}` }}</span
                  >
                </div>
                <div class="mt-3">
                  <span class="card__content__title">Address :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_store.store_address_th
                  }}</span>
                </div>
                <div class="mt-3">
                  <span class="card__content__title">Note to store :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_store.store_note ||
                    "-"
                  }}</span>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex xs12 sm5>
            <div>
              <div style="font-size: 16px; font-weight: 500; height: 7.5vh">
                <p style="text-align: center; position: relative; top: 2.5vh">
                  Customer Information
                </p>
              </div>
              <hr />
              <v-layout row wrap>
                <v-flex xs6
                  ><div>
                    <span class="card__content__title">Name :</span
                    ><span class="ms-2 card__content__value">{{
                      settransactionProfit.data.order.order_customer_full_name
                    }}</span>
                  </div></v-flex
                >
                <div>
                  <span class="card__content__title">Tel. :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_customer
                      .user_country_tel +
                    settransactionProfit.data.order.order_customer.user_tel
                  }}</span>
                </div>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6
                  ><div>
                    <span class="card__content__title">E-mail :</span
                    ><span class="ms-2 card__content__value">{{
                      settransactionProfit.data.order.order_customer
                        .user_email || "-"
                    }}</span>
                  </div></v-flex
                >
              </v-layout>

              <div
                style="background-color: #f3f5f7; padding: 1vw"
                class="p-5 mt-5"
              >
                <div>
                  <span class="card__content__title">Address :</span>
                  <span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_customer_address
                      .user_address_text
                  }}</span>
                </div>
                <v-flex xs12 class="d-flex mt-2">
                  <span class="card__content__title"> Tel. :</span
                  ><span
                    class="ms-2 card__content__value"
                    v-for="(store_tel, index) in settransactionProfit.data.order
                      .order_store.store_tel"
                    :key="index"
                    >{{ (index == 0 ? "" : ", ") + `${store_tel.tel}` }}</span
                  >
                  <span class="card__content__title">Distance from store :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_distance + " " + "m."
                  }}</span>
                </v-flex>
                <v-flex xs12 class="d-flex mt-2">
                  <span class="card__content__title">latitude :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_customer_address
                      .user_address_lat || "-"
                  }}</span>
                  <span class="card__content__title">longitude :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_customer_address
                      .user_address_long || "-"
                  }}</span>
                </v-flex>
                <div class="mt-3">
                  <span class="card__content__title">Place note :</span
                  ><span class="ms-2 card__content__value">{{
                    settransactionProfit.data.order.order_customer_address
                      .user_address_note || "-"
                  }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-10">
                <a
                  target="_blank"
                  :href="`https://www.google.co.th/maps/dir/${settransactionProfit.data.order.order_store.store_lat},${settransactionProfit.data.order.order_store.store_long}/${settransactionProfit.data.order.order_customer_address.user_address_lat},${settransactionProfit.data.order.order_customer_address.user_address_long}/data=!4m2!4m1!3e0`"
                >
                  <div
                    style="
                      background-color: #333333;
                      color: white;
                      border-radius: 5px;
                      height: 45px;
                      font-size: 16px;
                      font-weight: bold;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      padding: 0px 30px;
                      cursor: pointer;
                    "
                  >
                    <i
                      class="bi bi-geo-alt-fill"
                      style="color: white; font-size: 20px"
                    ></i
                    ><span class="ms-1"> MAP DESTINATION</span>
                  </div></a
                >
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="mt-5">
        <div class="body__card__title">Order Detail Product</div>
        <div class="p-10">
          <table style="width: 100%">
            <thead>
              <tr style="color: gray">
                <th>No.</th>
                <th>Store</th>
                <th>Product</th>
                <th class="text-center">Amount</th>
                <th>Price</th>
                <th>Option</th>
                <th>Note</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <hr />
            <tbody>
              <tr
                v-for="(product, productIndex) in settransactionProfit.data
                  .order.order_detail"
                :key="productIndex"
              >
                <td style="text-align: center">{{ productIndex + 1 }}</td>
                <td style="text-align: center">
                  {{
                    settransactionProfit.data.order.order_store.store_name_th
                  }}
                </td>
                <td style="text-align: center">
                  {{ product.order_detail_product.product_name_th }}
                </td>
                <td style="text-align: center">
                  {{ product.order_detail_amount }}
                </td>
                <td style="text-align: center">
                  {{ product.order_detail_product_seller_price }}
                </td>
                <td
                  v-if="product.order_detail_order_option.length > 0"
                  style="text-align: center"
                >
                  <div
                    v-for="(
                      optionItem, optionIndex
                    ) in product.order_detail_order_option"
                    :key="optionIndex"
                  >
                    <li
                      v-for="(choiceItem, choiceIndex) in optionItem
                        .order_option_option_choice.option_choice"
                      :key="choiceIndex"
                    >
                      {{ choiceItem.choice_name_th }}
                    </li>
                  </div>
                </td>
                <td v-else>-</td>
                <td style="text-align: center">
                  {{ product.order_detail_product.product_note || "-" }}
                </td>
                <td style="text-align: center">
                  {{ product.order_detail_total_product_price }}
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="card__content__title"
            style="display: flex; justify-content: center"
          >
            <div style="width: 50vw">
              <div
                style="display: flex; justify-content: space-between"
                class="mt-3"
              >
                <span>Item price</span
                ><span
                  >{{
                    settransactionProfit.data.order.order_total_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="display: flex; justify-content: space-between"
                class="mt-3"
              >
                <span>Transport price</span
                ><span
                  >{{
                    settransactionProfit.data.order.order_transfer_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="display: flex; justify-content: space-between"
                class="mt-3"
              >
                <span>Store package transport price</span
                ><span
                  >{{
                    settransactionProfit.data.order
                      .order_package_extra_transport_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="display: flex; justify-content: space-between"
                class="mt-3"
              >
                <span>Extra time transfer</span
                ><span
                  >{{
                    settransactionProfit.data.order
                      .order_transfer_extra_time_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="display: flex; justify-content: space-between"
                class="mt-3"
              >
                <span>Vat</span
                ><span
                  >{{
                    settransactionProfit.data.order.order_vat_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="display: flex; justify-content: space-between"
                class="mt-3"
              >
                <span>Service charge</span
                ><span
                  >{{
                    settransactionProfit.data.order.order_service_charge_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  color: red;
                "
                class="mt-3"
              >
                <span>Discount</span
                ><span
                  >{{
                    settransactionProfit.data.order.order_total_discount_price
                  }}
                  THB</span
                >
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  color: #4caf50;
                "
                class="mt-3"
              >
                <span>Net Price</span
                ><span
                  >{{
                    settransactionProfit.data.order.order_net_price
                  }}
                  THB</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="margin-top: 5vh"
      v-else-if="settransactionProfit.data.order.order_type == 2"
    >
      <div class="body__card__header">
        <div class="body__card__title">
          Detail Messenger Order #{{
            settransactionProfit.data.order.order_code
          }}
        </div>
        <v-layout row wrap>
          <v-container>
            <v-layout class="d-flex" xs12 sm5>
              <div style="font-size: 16px; font-weight: 500">
                <p style="text-align: center">Order Information</p>
                <div :span="24" :sm="12" class="p-10">
                  <div>
                    <hr />
                    <v-flex :span="24"
                      ><span class="card__content__title">Status :</span
                      ><span class="ms-2 card__content__value">{{
                        settransactionProfit.data.order.order_status == 1
                          ? "Order made"
                          : settransactionProfit.data.order.order_status == 2
                          ? "Inqueue"
                          : settransactionProfit.data.order.order_status == 3
                          ? "Cooking"
                          : settransactionProfit.data.order.order_status == 4
                          ? "Ready to pick"
                          : settransactionProfit.data.order.order_status == 5
                          ? "On the way"
                          : settransactionProfit.data.order.order_status == 6
                          ? "Completed"
                          : settransactionProfit.data.order.order_status == 7
                          ? "Canceled"
                          : "OTher"
                      }}</span></v-flex
                    >
                    <v-layout
                      ><v-flex :span="24" :sm="12" class="mt-3"
                        ><div>
                          <span class="card__content__title"
                            >Order coming date :</span
                          ><span class="ms-2 card__content__value">{{
                            moment(
                              settransactionProfit.data.order.order_time_start
                            ).format("YYYY-MM-DD")
                          }}</span>
                        </div></v-flex
                      ><v-flex :span="24" :sm="12" class="mt-3"
                        ><div>
                          <span class="card__content__title"
                            >Order coming time :</span
                          ><span class="ms-2 card__content__value">{{
                            moment(
                              settransactionProfit.data.order.order_time_start
                            ).format("HH:mm")
                          }}</span>
                        </div></v-flex
                      ></v-layout
                    >
                    <v-layout
                      ><v-flex :span="24" :sm="12" class="mt-3"
                        ><div>
                          <span class="card__content__title"
                            >Transfer date :</span
                          ><span class="ms-2 card__content__value">{{
                            moment(
                              settransactionProfit.data.order.order_time_end
                            ).format("YYYY-MM-DD")
                          }}</span>
                        </div></v-flex
                      ><v-flex :span="24" :sm="12" class="mt-3"
                        ><div>
                          <span class="card__content__title"
                            >Transfer time :</span
                          ><span class="ms-2 card__content__value">{{
                            moment(
                              settransactionProfit.data.order.order_time_end
                            ).format("HH:mm")
                          }}</span>
                        </div></v-flex
                      ></v-layout
                    >
                    <v-layout
                      ><v-flex :span="24" :sm="12" class="mt-3"
                        ><div>
                          <span class="card__content__title">COD :</span
                          ><span class="ms-2 card__content__value">{{
                            settransactionProfit.data.order
                              .order_payment_type == 1
                              ? "COD"
                              : settransactionProfit.data.order
                                  .order_payment_type == 2
                              ? "Credit card"
                              : settransactionProfit.data.order
                                  .order_payment_type == 3
                              ? "PromptPay"
                              : settransactionProfit.data.order
                                  .order_payment_type == 4
                              ? "COIN"
                              : settransactionProfit.data.order
                                  .order_payment_type == 5
                              ? "AR"
                              : "Other"
                          }}</span>
                        </div></v-flex
                      ><v-flex :span="24" :sm="12" class="mt-4"
                        ><div>
                          <span class="card__content__title">Pay Status :</span
                          ><span class="ms-2 card__content__value">{{
                            moment(
                              settransactionProfit.data.order.order_time_end
                            ).format("HH:mm")
                          }}</span>
                        </div></v-flex
                      ></v-layout
                    >
                    <div>
                      <span class="card__content__title">Note to rider :</span
                      ><span class="ms-2 card__content__value">{{
                        settransactionProfit.data.order.order_transfer_note ||
                        "-"
                      }}</span>
                    </div>
                    <v-flex :span="24" class="mt-3"></v-flex>
                    <v-flex :span="24" :sm="12" class="p-10">
                      <div
                        style="
                          font-size: 16px;
                          font-weight: 500;
                          padding: 20px;
                          align-items: center;
                        "
                      >
                        Destination Information ({{
                          settransactionProfit.data.order.order_points.length
                        }}
                        positions)
                      </div>
                      <hr />

                      <div
                        v-for="(n, i) in settransactionProfit.data.order
                          .order_points"
                        :key="i"
                      >
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                          "
                          class="mt-5"
                        >
                          <div class="pe-3">
                            <img
                              src="@/assets/back-office/pin_location.png"
                              alt=""
                              style="width: 15px"
                            />
                          </div>
                          {{ i + 1 }}: {{ n.order_point_address }}
                        </div>

                        <v-layout style="background-color: #e3e4ea">
                          <v-flex :span="24" :sm="12" class="mt-3 ml-3"
                            ><div>
                              <span class="card__content__title"
                                >Full name :</span
                              ><span class="ms-2 card__content__value">{{
                                n.order_point_to || "-"
                              }}</span>
                            </div></v-flex
                          ></v-layout
                        >
                        <v-layout style="background-color: #e3e4ea">
                          <v-flex :span="24" :sm="12" class="mt-3 ml-3">
                            <div>
                              <span class="card__content__title">Tel :</span
                              ><span class="ms-2 card__content__value">{{
                                n.order_point_list_tel || "-"
                              }}</span>
                            </div></v-flex
                          >
                          <v-flex :span="24" :sm="12" class="mt-3 mb-3">
                            <div>
                              <span class="card__content__title">Note :</span>
                              <span class="ms-2 card__content__value">{{
                                n.order_point_remark || "-"
                              }}</span>
                            </div></v-flex
                          >
                        </v-layout>
                      </div>
                    </v-flex>
                  </div>
                </div>
              </div>
              <div style="font-size: 16px; font-weight: 500; margin-left: 1vw">
                <p style="text-align: center">Customer Information</p>
                <v-flex :span="24" :sm="12" class="p-10">
                  <hr />
                  <v-layout
                    ><v-flex :span="24" :sm="12" class="mt-3"
                      ><div>
                        <span class="card__content__title">Name :</span
                        ><span class="ms-2 card__content__value">{{
                          settransactionProfit.data.order
                            .order_customer_full_name
                        }}</span>
                      </div></v-flex
                    ><v-flex :span="24" :sm="12" class="mt-3"
                      ><div>
                        <span class="card__content__title">Tel. :</span
                        ><span class="ms-2 card__content__value">{{
                          settransactionProfit.data.order.order_customer
                            .user_country_tel +
                          settransactionProfit.data.order.order_customer
                            .user_tel
                        }}</span>
                      </div></v-flex
                    ></v-layout
                  >
                  <v-flex class="mt-3"
                    ><div>
                      <span class="card__content__title">E-mail :</span
                      ><span class="ms-2 card__content__value">{{
                        settransactionProfit.data.order.order_customer
                          .user_email || "-"
                      }}</span>
                    </div></v-flex
                  >
                  <!-- map -->
                  <div
                    class="d-flex justify-content-center"
                    style="margin-top: 5vh"
                  >
                    <a
                      target="_blank"
                      :href="`https://www.google.co.th/maps/dir/${extractArrayString(
                        settransactionProfit.data.order.order_points
                      )}data=!4m2!4m1!3e0`"
                    >
                      <div
                        style="
                          background-color: #333333;
                          color: white;
                          border-radius: 5px;
                          height: 45px;
                          font-size: 16px;
                          font-weight: bold;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          padding: 0px 30px;
                          cursor: pointer;
                        "
                      >
                        <i
                          class="bi bi-geo-alt-fill"
                          style="color: white; font-size: 20px"
                        ></i
                        ><span class="ms-1"> MAP DESTINATION</span>
                      </div></a
                    >
                  </div>
                </v-flex>
              </div>
            </v-layout>
          </v-container>
        </v-layout>
      </div>
      <v-card style="margin-top: 5vh">
        <div class="body__card__title">Price information</div>
        <div
          class="p-10 card__content__title"
          style="display: flex; justify-content: center; padding-bottom: 2vh"
        >
          <div style="width: 50vw">
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: #ffa700;
              "
              class="mt-3"
            >
              <span>ระยะทางรวม</span
              ><span
                >{{
                  settransactionProfit.data.order.order_points.reduce(function (
                    previousValue,
                    currentValue
                  ) {
                    return (
                      previousValue +
                      parseFloat(currentValue.order_point_distance)
                    );
                  },
                  0)
                }}km</span
              >
            </div>
            <div
              style="display: flex; justify-content: space-between"
              class="mt-3"
            >
              <span>Transportation</span
              ><span
                >{{
                  settransactionProfit.data.order.order_transfer_price
                }}
                THB</span
              >
            </div>
            <div
              style="display: flex; justify-content: space-between"
              class="mt-3"
            >
              <span>Add on</span
              ><span
                >{{
                  settransactionProfit.data.order.order_total_addon_price
                }}
                THB</span
              >
            </div>
            <div
              style="display: flex; justify-content: space-between"
              class="mt-3"
            >
              <span>Extra point</span
              ><span
                >{{
                  settransactionProfit.data.order.order_store_extra_price
                }}
                THB</span
              >
            </div>
            <div
              style="display: flex; justify-content: space-between; color: red"
              class="mt-3"
            >
              <span>Discount</span
              ><span
                >{{
                  settransactionProfit.data.order.order_total_discount_price
                }}
                THB</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                color: #4caf50;
              "
              class="mt-3"
            >
              <span>Net Price</span
              ><span
                >{{ settransactionProfit.data.order.order_net_price }} THB</span
              >
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </v-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState({
      settransactionProfit: (state) => state.fetchUserBack.settransactionProfit,
    }),
  },
  methods: {
    extractArrayString(array) {
      let text = "";
      array.forEach(function (e) {
        text += e.order_point_lat + "," + e.order_point_long + "/";
      });
      return text;
    },
    ...mapActions({
      fetchtransactionProfitBill: "fetchUserBack/fetchtransactionProfitBill",
    }),
    async getDataProfit() {
      let idprofit = this.$route.params.transaction_partner_id;
      this.loadingMessage = true;
      await this.fetchtransactionProfitBill({
        profit_id: idprofit,
      });
      this.loadingMessage = false;
    },
  },
  created() {
    this.getDataProfit();
  },
};
</script>
<style scoped>
.card-body-custom {
  margin-left: 0px;
  padding: 20px;
  font-family: "Poppins", sans-serif;
}
.card {
  border-radius: 25px;
  width: 1400px;
  font-family: "Poppins", sans-serif;
}

.body__card__header {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e3e4ea;
  border-radius: 4px;
}

.body__card__title {
  background: #ffeb52 0% 0% no-repeat padding-box;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  padding: 15px;
}

.card__content__item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #666666;
  color: white;
  padding: 10px 20px;
}

.card__content__title {
  font-weight: 500;
  font-size: 14px;
}

.card__content__value {
  color: #6a6266;
  font-weight: 400;
  font-size: 14px;
}

.align_end {
  text-align: end;
}
</style>
